export const environment = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8005/api/v1/',
  production: process.env.NODE_ENV === 'production'
};

export const environmentProd = {
  apiUrl: 'https://coupons.e2e.co.uk/api/v1/',
  production: true
};
